export default {
	// get user info
	setLoginIdentity({commit}, val) {
		commit('setLoginIdentity', val)
	},
	setLoginAccount({commit}, val) {
		commit('setLoginAccount', val)
	},
	setAccountBalance({commit}, val) {
		commit('setAccountBalance', val)
	}
}
